import { ActionIcon, Group, Text } from '@mantine/core';
import { IconThumbDown, IconThumbUp } from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales/index';
import { isNonNullish } from 'remeda';
import { useCreateSummaryFeedback } from 'shared/hooks/use-create-summary-feedback';

import type { AiSummary } from './hooks/use-load-debtor-ai-summary';

type FeedbackRatingIconProps = {
  debtorId: string;
  aiSummary: NonNullable<AiSummary>;
};

export const FeedbackRatingIcon = ({ debtorId, aiSummary }: FeedbackRatingIconProps) => {
  const { t } = useTranslation();

  const { createSummaryFeedback } = useCreateSummaryFeedback();

  const handleFeedback = (rating: boolean) => {
    createSummaryFeedback({ summaryId: aiSummary.id, rating, debtorId: String(debtorId) });
  };

  if (isNonNullish(aiSummary.rating))
    return (
      <Text fs="italic" c="dimmed" size="sm">
        {t(i18nKeys.AI_SUMMARY.THANKS_FOR_FEEDBACK)}
      </Text>
    );

  return (
    <Group>
      <ActionIcon.Group>
        <ActionIcon onClick={() => handleFeedback(true)} variant="subtle" color="green">
          <IconThumbUp size={22} stroke={1.5} />
        </ActionIcon>
        <ActionIcon onClick={() => handleFeedback(false)} variant="subtle" color="error.9">
          <IconThumbDown size={22} stroke={1.5} />
        </ActionIcon>
      </ActionIcon.Group>
    </Group>
  );
};
